(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/page-category-games-standalone/assets/javascripts/root-lb.js') >= 0) return;  svs.modules.push('/components/casino-react/page-category-games-standalone/assets/javascripts/root-lb.js');

'use strict';

const PageCategoryGamesStandalone = svs.components.casino_react.pageCategoryGamesStandalone.PageCategoryGamesStandalone;
const baseUrl = svs.core.data.baseUrl;
const _ReactRouterDOM = ReactRouterDOM,
  BrowserRouter = _ReactRouterDOM.BrowserRouter;
const _ReactRedux = ReactRedux,
  Provider = _ReactRedux.Provider;
const store = svs.components.casino_react.casinoStore.store;

function Root(_ref) {
  let isLiveCasino = _ref.isLiveCasino,
    currentCategory = _ref.currentCategory,
    currentCategoryList = _ref.currentCategoryList;
  return React.createElement("div", {
    className: "theme-lb-casino"
  }, React.createElement(BrowserRouter, {
    basename: baseUrl
  }, React.createElement(Provider, {
    store: store
  }, React.createElement(PageCategoryGamesStandalone, {
    currentCategory: currentCategory,
    currentCategoryList: currentCategoryList,
    isLiveCasino: isLiveCasino,
    renderSubHeader: true
  }))));
}
setGlobal('svs.components.casino_react.pageCategoryGamesStandalone.RootLb', Root);

 })(window);